/* eslint-disable import/first */
import React, { useEffect, useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
import { Radio, Button, Grid, Dialog } from '@material-ui/core';
import { useNavigate, useLocation } from '@reach/router';
import { v4 as uuidv4 } from 'uuid';
import { FormattedMessage, useIntl } from 'react-intl';
const { useSelector, useDispatch, shallowEqual } = Redux;
import { PartyPopper, TickCircle } from '../../../components/Icons';
import DialogWrapper from '../../../components/DialogWrapper';
import OfferApplied from '../../OfferApplied';
import { makeStyles } from '@material-ui/core/styles';
const { selectDesktop } = Slices.appSlice;
const { selectProductEntities } = Slices.productSlice;
const { selectBaseURL } = Slices.configSlice;
const { addCoupon } = Slices.offerSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { sendCart } = Slices.cartSlice;
// const { fetchProductsByCategoryId } = Slices.productSlice;
const { selectFirstMenu, fetchDiscountedItems, selectDiscountedItems } = Slices.menuSlice;
import css from './index.module.scss';
import noImg from '../../../assets/no-itm.png';
import Loader from '../../../components/Loader';
import artWork from '../../Offers/offerArtwork.svg';

export default function FreeItemSelection({
  isOpen,
  onClose,
  isDiscountedItem,
  isFreeItem,
  freeCatId,
}) {
  const isDesktop = useSelector(selectDesktop);
  const cart = useSelector((state) => state.cart);
  const products = useSelector(selectProductEntities, shallowEqual);
  const imgBaseUrl = useSelector(selectBaseURL);
  const [confettiStatus, setConfettiStatus] = useState(false);
  const address = useSelector(selectDefaultAddress);
  const discountedProducts = useSelector(selectDiscountedItems);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const profile = useSelector((state) => state.profile);
  const menu = useSelector(selectFirstMenu);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [pageLoader, setPageLoader] = React.useState(false);
  const [discountedProductsList, setDiscountedProductsList] = React.useState([]);
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // debugger;
  const currencyIcon = menu ? menu.currency : 'AED';
  // console.log(isFreeItem, 'free122222');
  // useEffect(() => {
  //   // if (isDiscountedItem) {
  //   //   dispatch(fetchDiscountedItems({ categoryId: cart?.data?.freeCategoryId }));
  //   // }
  //   if (isFreeItem) {
  //     dispatch(
  //       fetchDiscountedItems({
  //         id: cart?.data?.freeCategoryId,
  //         cluster: cart?.data?.clusterId,
  //         Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
  //       })
  //     );
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isFreeItem]);

  useEffect(() => {
    setSelectedProduct(null);
    setDiscountedProductsList([]);
  }, [isOpen]);

  useEffect(() => {
    let items = discountedProducts[cart.data.freeCategoryId] || [];
    items = items.map((item) => products[item]);
    setDiscountedProductsList(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discountedProducts]);

  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      // maxWidth: '26rem',
      borderRadius: '2rem',
      backgroundColor: '#F1F3F6',
      backgroundImage: `url(${artWork})`,
      height: 'auto',
      width: '26rem',
    },
  }));
  const vardialogPaper = useStyles();

  const addToCart = () => {
    const prod = products[selectedProduct];
    setPageLoader(true);
    const CustomID = uuidv4();
    let mainProduct = [];
    if (isDiscountedItem) {
      mainProduct[0] = {
        ...prod,
        catId: cart?.data?.discountPromo?.categoryId,
        isDiscounted: true,
        qty: 1,
        UUID: CustomID,
        calculatedPrice: prod.finalPrice,
        sellingPrice: prod.finalPrice,
      };
    } else {
      if (prod.typeId === 'simple') {
        mainProduct[0] = {
          id: prod?.id,
          catId: prod?.category || prod?.categories[0],
          price: prod?.currentPrice || prod?.specialPrice || prod.originalPrice,
          typeId: 'simple',
          qty: 1,
          // isDefault: true,
          freeItem: true,
        };
      }
    }
    let items = [];
    items.push(mainProduct[0]);
    if (cart.data.items.length !== 0) {
      items = [...cart?.data?.items, ...items];
    }

    let addressType = 'DELIVERY';
    let addressSubType = 'DELIVERY';
    if (Object.entries(address).length) {
      addressType = address.addressType;
      addressSubType = address.addressSubType;
    }
    const payload = {
      items: items,
      body: {
        addressSubType: addressSubType,
        addressType: addressType,
        addressId: address?.id || '',
        cartId: profile.data.data[0].cartId || '',
        applySurprisePromo:
          (isDiscountedItem ? cart?.data?.discountPromo?.couponCode : cart.data.usedCouponCode) > 0,
        couponCode: isDiscountedItem
          ? cart?.data?.discountPromo?.couponCode
          : cart.data.usedCouponCode,
        clusterId: cart?.data?.clusterId || '',
        items: items,
        version: 'v20',
        orderType: addressType,
        storeId: address?.storeId,
      },
      headers: {
        country: profile.country,
      },
    };

    const applyCoupon = (offer) => {
      dispatch(addCoupon(offer));
    };

    dispatch(sendCart(payload)).then((res) => {
      if (!res.error) {
        const responseLoad = res.payload.data.data;
        if (isDiscountedItem || isFreeItem) {
          applyCoupon(responseLoad.promo);
        }

        isDesktop
          ? navigate(`/${intl.locale}/offer-applied`, {
              state: {
                oldLocation: location?.state?.cartLocation || JSON.parse(JSON.stringify(location)),
                isFreeItem: isDiscountedItem ? false : true,
                isDiscountedItem: isDiscountedItem,
              },
            })
          : setConfettiStatus(true);
      }
      setPageLoader(false);
      if (res.error) {
        setPageLoader(false);
      }
    });
  };
  const productItem = (data) => {
    const productDetail = products[data.id];
    return (
      <div onClick={() => setSelectedProduct(data.id)} className={css.productItem}>
        {pageLoader && <Loader />}
        <div className={css.product}>
          <img
            className={css.productImage}
            src={`${data.assets[0]?.src}`}
            alt={data.name}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = noImg;
              e.target.width = 150;
              e.target.height = 150;
            }}
          />
          <div className={css.productTextContainer}>
            <p className={css.productName}>{productDetail.name}</p>
            <div className={css.productPriceContainer}>
              {data.originalPrice > 0 && (
                <p className={css.originalPrice}>
                  {data.originalPrice} {currencyIcon}
                </p>
              )}
              <p className={css.discountPrice}>
                {isDiscountedItem ? (
                  <>
                    {data.finalPrice - cart?.data?.discountPromo?.discountAmount > 0 ? (
                      <span>
                        {data.finalPrice - cart?.data?.discountPromo?.discountAmount} {currencyIcon}
                      </span>
                    ) : (
                      <FormattedMessage id="free" defaultMessage="free" />
                    )}
                  </>
                ) : (
                  <>{data.sellingPrice || <FormattedMessage id="free" defaultMessage="free" />}</>
                )}
              </p>
            </div>
          </div>
        </div>
        <div className={css.selectorContainer}>
          <Radio
            checked={selectedProduct === data.id}
            color="primary"
            id={'idx'}
            edge="end"
            onChange={() => setSelectedProduct(data.id)}
          />
        </div>
      </div>
    );
  };
  const getProductList = () => {
    return configureDiscountedItem();
  };

  const configureDiscountedItem = () => {
    console.log(discountedProductsList, 'free999');
    const items = discountedProductsList?.filter((item) => {
      if (item?.id) {
        return true;
      }
      return false;
    });
    if (!selectedProduct && items.length) {
      setSelectedProduct(items[0]?.id);
    }

    return discountedProductsList.map((itemsD, index) => {
      if (itemsD) {
        return productItem(itemsD);
      }
    });
  };

  // const configureFreeItems = () => {
  //   // if (cart?.data?.freeItems) {
  //   // const freeItems = cart?.data?.freeItems[intl.locale.toLowerCase()]?.filter((item) => {
  //   //   if (products[item.id]) {
  //   //     return true;
  //   //   }
  //   //   return false;
  //   // });
  //   if (!selectedProduct && freeItems.length > 0) {
  //     setSelectedProduct(freeItems[0]?.id);
  //   }

  //   return freeItems.map((items) => {
  //     return productItem(items);
  //   });
  //   // }
  // };

  const handleClose = () => {
    setConfettiStatus(false);
  };
  return (
    <div>
      {confettiStatus && (
        <Grid>
          <Dialog open={confettiStatus} classes={{ paper: vardialogPaper.dialogPaper }}>
            <OfferApplied
              vardialogPaper={vardialogPaper}
              handleClose={handleClose}
              freeItem={isDiscountedItem}
              cartData={cart?.data?.promo}
            />
          </Dialog>
        </Grid>
      )}
      <DialogWrapper isOpen={isOpen} onClose={onClose}>
        <div className={css.root}>
          {/* <div className={css.badge}>
            <Badge />
          </div> */}
          <div className={css.popperContainer}>
            <PartyPopper className={css.leftPopper} />
            <PartyPopper className={css.rightPopper} />
          </div>
          <div className={css.main}>
            <div className={css.titleHeadText}>
              <FormattedMessage id="woohoo" defaultMessage="Woohoo!" />
            </div>
            <div className={css.subtitleText}>
              <FormattedMessage
                id="unlocked_discount_item"
                defaultMessage="unlocked_discount_item!"
              />
            </div>
            <div className={css.productList}>
              <div className={css.titleText}>
                {/* <FormattedMessage
                  id={isDiscountedItem ? 'select_your_discount_item' : 'select_your_free_item'}
                /> */}
              </div>
              <div className={css.productSelection}>{getProductList()}</div>
            </div>
            <div className={css.actionContainer}>
              <Button variant="outlined" className={css.removeBtn} onClick={onClose}>
                <FormattedMessage id="remove" />
              </Button>
              <Button
                className={css.addBtn}
                variant="contained"
                color="primary"
                onClick={addToCart}
                disabled={!selectedProduct}
              >
                Add to Cart
              </Button>
            </div>
          </div>
        </div>
      </DialogWrapper>
    </div>
  );
}
